import { InjectionToken } from "@angular/core";

const AUTH_ROUTE_PATH = new InjectionToken<string>('Authentication Route Path');

export {
    AUTH_ROUTE_PATH
};